import { InvalidAspectRatioError } from "../errors";
import { BaseOptionItem } from "./types";

// Most of this should eventually be moved to the model specs
// since models sometimes define their own weird notions

export const RESOLUTIONS = [
  { label: "720p", value: "720p" },
  { label: "1080p", value: "1080p" },
] as const;

export const VIDEO_ASPECT_RATIOS = [
  { label: "9:16", value: "9:16" },
  { label: "16:9", value: "16:9" },
] as const;

export const DURATIONS = [
  { label: "4s", value: "4" },
  { label: "8s", value: "8" },
  { label: "12s", value: "12" },
] as const;

export const RESOLUTION_TO_WIDTH_HEIGHT_MAP = {
  "720p": {
    "16:9": { width: 1280, height: 720 },
    "9:16": { width: 720, height: 1280 },
  },
  "1080p": {
    "16:9": { width: 1920, height: 1080 },
    "9:16": { width: 1080, height: 1920 },
  },
} as const;

export const SORA_RESOLUTION_TO_WIDTH_HEIGHT_MAP = {
  "720p": {
    "16:9": { width: 1280, height: 720 },
    "9:16": { width: 720, height: 1280 },
  },
  "1080p": {
    "16:9": { width: 1792, height: 1024 },
    "9:16": { width: 1024, height: 1792 },
  },
} as const;

export const OPENAI_SORA_SIZE_MAP = {
  "720p": {
    "16:9": "1280x720",
    "9:16": "720x1280",
  },
} as const;

export const OPENAI_SORA_PRO_SIZE_MAP = {
  "720p": {
    "16:9": "1280x720",
    "9:16": "720x1280",
  },
  "1024p": {
    "16:9": "1792x1024",
    "9:16": "1024x1792",
  },
  "1080p": {
    "16:9": "1920x1080",
    "9:16": "1080x1920",
  },
} as const;

export const OPENAI_GPT_IMAGE_SIZE_MAP = {
  "1:1": "1024x1024",
  "16:9": "1536x1024",
  "9:16": "1024x1536",
} as const;

export const KLING2_5_PRO_RESOLUTION_TO_WIDTH_HEIGHT_MAP = {
  "16:9": { width: 1280, height: 720 },
  "9:16": { width: 720, height: 1280 },
  "1:1": { width: 720, height: 720 },
} as const;

export const KLING2_6_PRO_RESOLUTION_TO_WIDTH_HEIGHT_MAP = {
  "16:9": { width: 1920, height: 1080 },
  "9:16": { width: 1080, height: 1920 },
  "1:1": { width: 1440, height: 1440 },
} as const;

export const COMMON_ASPECT_RATIOS: readonly BaseOptionItem[] = [
  { label: "1:1", value: "1:1" },
  { label: "9:16", value: "9:16" },
  { label: "16:9", value: "16:9" },
  { label: "4:3", value: "4:3" },
  { label: "3:4", value: "3:4" },
] as const;

const COMMON_ASPECT_RATIOS_MAP = {
  "16:9": { width: 1280, height: 720 },
  "9:16": { width: 720, height: 1280 },
  "1:1": { width: 1024, height: 1024 },
  "4:3": { width: 1280, height: 896 },
  "3:4": { width: 896, height: 1280 },
} as const;

const ALLOWED_ASPECT_RATIOS = Object.keys(COMMON_ASPECT_RATIOS_MAP);

type AllowedAspectRatio = keyof typeof COMMON_ASPECT_RATIOS_MAP;

export function getAspectRatioDimension(aspectRatio: AllowedAspectRatio) {
  if (ALLOWED_ASPECT_RATIOS.includes(aspectRatio)) {
    return COMMON_ASPECT_RATIOS_MAP[aspectRatio];
  }
  throw new InvalidAspectRatioError(`Invalid aspect ratio: ${aspectRatio}`);
}
